
import { useSearchParams } from "react-router";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import "./GestionFases.scss";
import { useQuery } from "@tanstack/react-query";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors, type DragEndEvent } from "@dnd-kit/core";
import { memo, useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { notificacion, notificacionTipo } from "../../../components/Alerts";
import { Loading } from "../../../components/Loading/Loading";
import { useLocalStorage } from "@/hooks/useLocalStorage";

export function GestionFasesPage() {
	const [search] = useSearchParams();
	// useEffect(() => {
	// 	const timer = setInterval(() => {
	// 		const search = (Math.random() * 20000).toString(36);
	// 		console.log(search);

	// 		setLocation({ search: search });
	// 	}, 5000);
	// 	return () => clearInterval(timer);
	// }, [location]);

	const puesto = search.get("idPuesto") ?? "";

	return (
		<div id="content" className="content" >
			<title>Almacen | Gestión de Fases </title>
			{/*Content*/}

			{puesto == "" && (
				<ContenedorPuestos />
			)}
			{puesto != "" && (
				<TablaFases idPuesto={puesto} />
			)}
		</div>
	);
}


function ContenedorPuestos() {
	const { data, isLoading, error } = UsePuestos();

	if (isLoading) {
		return <div>Cargando...</div>;
	}
	if (error) {
		return <div>Error al cargar los puestos</div>;
	}
	return <>
		<Breadcrumb
			sectionTitle="Gestión de Puestos"
			links={[
				{ label: "Gestión de Puestos", active: true }
			]}
		/>
		<div id="contenedorBotones">
			{data?.map(puesto => (
				<BotonPuesto key={puesto.idPuesto} puesto={puesto} />
			))}
		</div>
	</>;

}
function BotonPuesto(props: { readonly puesto: Puesto; }) {
	const [_, setSearch] = useSearchParams();
	const onClick = () => setSearch({ idPuesto: props.puesto.idPuesto });

	return (
		<button className="botonPuesto" onClick={onClick} type="button">
			<h3 className="idPuesto">{props.puesto.idPuesto}</h3>
			<h4 className="nombrePuesto">{props.puesto.descripcion.replace(props.puesto.idPuesto, "")}</h4>
			<div style={{ flex: 1 }}></div>
			<div className="indicadorHoras">
				Carga de trabajo: <b>{props.puesto.cantidadHoras}h</b>
			</div>
		</button>
	);
}

function TablaFases(props: { readonly idPuesto: string; }) {
	const [local, setLocal] = useLocalStorage<Record<string, number>>("impresiones", {});
	const { data, isPending, error } = UseFases(props.idPuesto);
	const [items, setItems] = useState<FaseWithID[]>([]);
	const [dirty, setDirty] = useState(false);
	const [sorting, setSorting] = useState(true);
	const [selection, setSelection] = useState<string[]>([]);

	useEffect(() => {
		if (data) {
			setItems(data);
		}
	}, [data]);

	const sensors = useSensors(
		useSensor(PointerSensor),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		})
	);

	function handleDragEnd(event: DragEndEvent) {
		const { active, over } = event;
		if (!over) return;

		if (active.id !== over.id) {
			setDirty(true);
			setItems((items) => {
				const oldIndex = items.findIndex(item => item.id === active.id);
				const newIndex = items.findIndex(item => item.id === over.id);

				return arrayMove(items, oldIndex, newIndex);
			});
		}
	}

	const onSetPrinting = () => {
		if (dirty) {
			notificacionTipo("error", "No se puede imprimir fases cuando hay cambios en el orden sin guardar.");
		} else {
			setSorting(false);
			setSelection(items.map((it) => it.id).filter((id) => !(id in local)));
		}
	};

	const onImprimirSeleccionadas = () => {
 		void ComunicacionAjax.sendAjaxRequest<ResPrintOF>("POST", "/api/v1/printOrdenesFabricacion", {
			idsToPrint: items.filter((item) => selection.includes(item.id)).map((item) => ({ idOF: item.idOF, idFase: item.idFase }))
		}).then((res) => {
			if (res.status != "exito") return notificacionTipo("error", res.message);

			const updated = { ...local };
			for (const id of selection) {
				updated[id] = (updated[id] ?? 0) + 1;
			}
			setLocal(updated);
			setSorting(true);
			window.open(res.printPDF, "_blank");
		});
	};

	const onGuardarCambios = () => {
		void ComunicacionAjax.sendAjaxRequest<ResOrderPuesto>("POST", "/api/v1/setOrderPuesto", {
			idPuesto: props.idPuesto,
			nuevoOrden: items.map((fase, index) => ({ "idOF": fase.idOF, "faseOF": fase.idFase, "idPuesto": props.idPuesto, "orden": index + 1 }))
		}).then((res) => {
			if (res.status != "exito") return notificacionTipo("error", res.message);

			setDirty(false);
			notificacion(res.message);
			window.open(res.ordenPDF, "_blank");
		});
	};


	if (isPending) return <Loading />;
	if (error) {
		return <div>Error al cargar las fases</div>;
	}

	return <>
		<Breadcrumb
			sectionTitle="Gestión de Puestos"
			links={[
				{ label: "Gestión de Puestos", to: "/gestionfases" },
				{ label: "Puesto " + props.idPuesto, active: true }
			]}
		/>

		<div id="sortable-wrapper" style={{ overflow: "auto", borderBottom: "1px solid #333" }}>
			<table id="sortableFases" style={{ width: "100%", overflow: "clip" }}>
				<thead style={{ position: "sticky", top: "0px", zIndex: "1" }}>
					<tr>
						<th></th>
						<th>OF-Fase</th>
						<th>Operacion</th>
						<th>Conjunto</th>
						<th>Cantidad</th>
						<th>Fecha Inicio</th>
						<th>Fecha Fin</th>
					</tr>
				</thead>
				<tbody className="ui-sortable">
					<DndContext
						sensors={sensors}
						collisionDetection={closestCenter}
						onDragEnd={handleDragEnd}
						accessibility={{ container: document.getElementById("my-a11y-container-id")! }}
					>
						<SortableContext items={items} strategy={verticalListSortingStrategy} >
							{items.map(fase => (
								<SortableRow
									key={fase.id}
									orden={fase}
									selection={selection}
									setSelection={setSelection}
									sorting={sorting} />
							))}
						</SortableContext>
					</DndContext>
				</tbody>
			</table>
		</div>

		<div id="my-a11y-container-id" />

		<div style={{ display: "flex", padding: "10px 0", justifyContent: "space-between" }}>
			{sorting ? <>
				<button className={!dirty ? "btnPrimary" : "btnSecondary"} onClick={onSetPrinting} type="button">
					Imprimir fases
				</button>
				<button className="btnPrimary" onClick={onGuardarCambios} type="button">
					Guardar cambios
				</button>
			</> : <>
				<button className="btnSecondary" onClick={() => setSorting(true)} type="button">
					Cancelar
				</button>
				<button className="btnPrimary" onClick={onImprimirSeleccionadas} type="button">
					Imprimir seleccionadas
				</button>
			</>}
		</div>
	</>;
}

interface RowProps {
	readonly orden: FaseWithID;
	readonly selection: string[];
	readonly setSelection: Dispatch<SetStateAction<string[]>>;
	readonly sorting: boolean;
}

function SortableRow(props: RowProps) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({ id: props.orden.id, disabled: !props.sorting });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		cursor: props.sorting ? "grab" : "auto",
	};

	return (
		<tr ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<RowContent {...props} />
		</tr>
	);
}

const RowContent = memo(({ orden, selection, setSelection, sorting }: RowProps) => {
	const formatter = new Intl.DateTimeFormat("es-ES", { year: "numeric", month: "2-digit", day: "2-digit" });
	const formatDate = (timestamp: number | null) => timestamp ? formatter.format(new Date(timestamp * 1000)) : "-";

	const toggleRow = (checked: boolean) => {
		if (checked) {
			setSelection([...selection, orden.id]);
		} else {
			setSelection((prev) => prev.filter((id) => id !== orden.id));
		}
	};

	return <>
		{sorting ? (
			<td className="dt-center noClick" style={{ textAlign: "center" }}>
				<i className="fa fa-arrows-alt" style={{ width: "100%" }} />
			</td>
		) : (
			<td className="checkbox" style={{ textAlign: "center" }}>
				<input
					type="checkbox"
					checked={selection.includes(orden.id)}
					onChange={(e) => toggleRow(e.currentTarget.checked)}
					style={{ marginTop: "0", width: "1em", height: "1em" }}
				/>
			</td>
		)}
		<td style={{ fontWeight: "bold" }}>{orden.id}</td>
		<td>{orden.descripcionFase}</td>
		<td>{orden.idArticulo} - {orden.descripcionArticulo}</td>
		<td>{orden.cantAcabada}/{orden.cantLanzada} ({orden.cantidadOF})</td>
		<td>{formatDate(orden.timestampIni)}</td>
		<td>{formatDate(orden.timestampFin)}</td>
	</>;
});
RowContent.displayName = "RowContent";

function UsePuestos() {
	return useQuery({
		queryKey: ["getMaquinasConCarga"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<Puesto[]>("GET", "/api/v1/getMaquinasConCarga");
		}
	});
}
interface Puesto {
	idPuesto: string;
	descripcion: string;
	cantidadHoras: number;
}

function UseFases(idPuesto: string) {
	return useQuery<FaseWithID[]>({
		queryKey: ["getFasesPuesto", idPuesto],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<FasesOrden>("GET", "/api/v1/getFasesPuesto", { idPuesto: idPuesto })
				.then(fases => {
					const mapped = fases.fases.map(fase => ({ ...fase, id: `${fase.idOF}-${fase.idFase}` }));
					if (fases.orden != null) {
						return mapped.sort((a, b) => {
							const indexA = fases.orden?.findIndex(o => o.idOF === a.idOF && o.faseOF === a.idFase);
							const indexB = fases.orden?.findIndex(o => o.idOF === b.idOF && o.faseOF === b.idFase);
							return (indexA ?? -1) - (indexB ?? -1);
						});
					}

					return mapped;
				});
		},
	});
}
interface FasesOrden {
	fases: Fase[];
	orden: Array<{ idOF: number; faseOF: number; idPuesto: string; orden: number; }> | null;
}
interface Fase {
	idOF: number;
	idPuesto: string;
	idRuta: string;

	idFase: number;
	descripcionFase: string;

	idArticulo: string;
	descripcionArticulo: string;

	cantAcabada: number | null;
	cantLanzada: number | null;
	cantRechazada: number | null;
	cantidadOF: number | null;

	timestampIni: number | null;
	timestampFin: number | null;
}
type FaseWithID = Fase & { id: string; };

interface ResPrintOF {
	status: string;
	message: string;
	printPDF: string;
}

interface ResOrderPuesto {
	status: string;
	message: string;
	ordenPDF: string;
}